module.exports = __webpack_public_path__ + "img/sdg_pt-pt_(6).5d2d24c3.png";